import { render } from "./tools.vue?vue&type=template&id=1aca9713"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"

import exportComponent from "E:\\demo\\vue3-tree-org\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__